import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function ProductSection() {
  return <Section className="bg-[#FDF8F3]" data-id="element-130">
      <FadeIn data-id="element-131">
        <div className="text-center mb-12" data-id="element-132">
          <span className="text-[#E8872B] font-bold tracking-wider uppercase text-sm" data-id="element-133">
            Presentando
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#2D2A26] mt-2 mb-6" data-id="element-134">
            Casa Sin Olor — Protocolo 7 Días
          </h2>
          <p className="text-xl text-[#2D2A26]/70" data-id="element-135">(Perros + Gatos)</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-136">
          <div className="p-8 md:p-12" data-id="element-137">
            <p className="text-lg text-[#2D2A26] mb-8 font-medium" data-id="element-138">
              Un PDF práctico (sin relleno) diseñado para romper el ciclo del
              olor en una semana:
            </p>

            <ul className="space-y-4" data-id="element-139">
              <li className="flex items-start gap-3" data-id="element-140">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-141">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-142" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-143">
                  <strong data-id="element-144">Diagnóstico en 10 minutos</strong> para encontrar tu
                  “zona culpable”
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-145">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-146">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-147" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-148">
                  El sistema <strong data-id="element-149">4Z</strong> explicado simple (sin
                  tecnicismos)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-150">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-151">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-152" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-153">
                  El plan <strong data-id="element-154">12×7</strong>: 12 minutos al día por 7 días
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-156">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-157" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-158">
                  <strong data-id="element-159">Checklists imprimibles</strong> (para no pensar, solo
                  ejecutar)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-160">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-161">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-162" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-163">
                  Mantenimiento mínimo semanal (para que no vuelva)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-164">
                <div className="bg-[#5BBFB5]/10 p-1 rounded-full mt-1" data-id="element-165">
                  <Check className="w-5 h-5 text-[#5BBFB5]" data-id="element-166" />
                </div>
                <span className="text-[#2D2A26]/80 text-lg" data-id="element-167">
                  <strong data-id="element-168">Plan de emergencia:</strong> “vienen visitas hoy”
                  (30–45 min)
                </span>
              </li>
            </ul>

            <div className="mt-10 p-6 bg-gray-50 rounded-xl border border-gray-200" data-id="element-169">
              <h3 className="font-bold text-[#2D2A26] mb-4" data-id="element-170">
                Lo que este producto NO es:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-[#2D2A26]/70" data-id="element-171">
                <p data-id="element-172">❌ No es “limpia más”</p>
                <p data-id="element-173">❌ No es “compra 20 productos”</p>
                <p data-id="element-174">❌ No es “perfuma y ya”</p>
                <p data-id="element-175">❌ No es una promesa médica</p>
              </div>
              <p className="mt-4 pt-4 border-t border-gray-200 font-medium text-[#2D2A26]" data-id="element-176">
                Es un sistema doméstico para lograr lo que de verdad quieres:{' '}
                <strong data-id="element-177">que tu casa huela a nada.</strong>
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}